import { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { UIContext } from 'Context/UI'
import { TableContext } from 'Context/Table'

import { MarketplaceFilter } from 'Configuration/MarketplaceFilter'
import { useLang } from '_metronic/i18n/Metronici18n'

import { MOCK_DATA } from 'Data/mockMarketplaceOrder'

const ViewModel = () => {
	const lang = useLang()
	const navigate = useNavigate()
	const { setShowContentToolbar, setCustomContentToolbar } = useContext(UIContext)
	const { updateLoading, updatePagination, updateSorting, updateError } = useContext(TableContext)
	const [currentStatus, setCurrentStatus] = useState<string>('all')
	const [isLoading, setIsLoading] = useState<boolean>(true)

	const statusFilters = useMemo(
		() =>
			Object.entries(MarketplaceFilter).map(([key, value]) => ({
				// @ts-ignore
				label: MarketplaceFilter[key][lang],
				value: MarketplaceFilter[key].value,
				number: key === 'all' ? undefined : Math.floor(Math.random() * 9) + 1,
				numberColor: ['green', 'white', 'grey'][Math.floor(Math.random() * 3)],
			})),
		[lang]
	)
	const filterOptionsAvailable = useMemo(
		() => [
			{
				label: lang === 'en' ? 'Order Code' : 'หมายเลขคำสั่งซื้อ',
				value: 'orderCode',
			},
		],
		[lang]
	)

	const totalData = useMemo(() => MOCK_DATA.length, [])
	const data = useMemo(() => MOCK_DATA, [])

	const setupUI = () => {
		setShowContentToolbar(false)
		setCustomContentToolbar(null)
		updatePagination(false)
		updateSorting('product', true)
	}

	const resetUI = () => {
		setShowContentToolbar(true)
		setCustomContentToolbar(null)
	}

	const fetchData = () => {
		setIsLoading(true)
		updateLoading(true)
		updateError(false)

		setTimeout(() => {
			setIsLoading(false)
			updateLoading(false)
		}, 1000)
	}

	const onChangeFilterStatus = (status: string) => {
		setCurrentStatus(status)
	}

	const onViewDetail = (uuId: string) => {
		navigate(`/marketplace/detail/${uuId}`)
	}

	useEffect(() => {
		setupUI()

		return () => {
			resetUI()
		}
		// eslint-disable-next-line
	}, [])

	useEffect(() => {
		fetchData()
		// eslint-disable-next-line
	}, [])

	return {
		statusFilters: statusFilters.map(status => ({
			label: status.label,
			isActive: currentStatus === status.value,
			value: status.value,
			number: status.number,
			numberColor: status.numberColor,
		})),
		filterOptions: filterOptionsAvailable,
		isLoading,
		totalData,
		data,
		onChangeFilterStatus,
		onViewDetail,
	}
}

export default ViewModel
